import React from 'react'
import { useTransition, animated } from 'react-spring'
import * as styles from './styles'

interface Props {
  zIndex?: number
  onClick?: () => void
  visible?: boolean
}

const Overlay: React.FC<Props> = ({ zIndex = 1, onClick, visible }) => {
  const overlayTransition = useTransition(visible, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
  })

  return (
    <>
      {overlayTransition((style, item) =>
        item ? (
          <animated.div
            style={{ ...style, zIndex }}
            className={`${styles.root} ${visible ? '' : 'disabled-click'}`}
            onClick={onClick}
          ></animated.div>
        ) : (
          ''
        ),
      )}
    </>
  )
}

export default Overlay
